<template>
  <div class="page">
    <TopNav
        :username="username"
        :balance="topBalance"
        :currency="currency"
        activeLv1="balance"
        activeLv2=""
        @nav="onNav"
        @sub="onSub"
    />

    <div class="wrap">
      <div class="grid">
        <!-- 左：Account Info -->
        <table class="tbl">
          <thead>
          <tr><th colspan="2">{{$t('Balance.AccountInfo')}}</th></tr>
          </thead>
          <tbody>
          <tr>
            <td class="k">{{$t('Balance.Account')}}</td>
            <td class="v">{{ account }}</td>
          </tr>
          <tr>
            <td class="k">{{$t('Balance.UserName')}}</td>
            <td class="v">{{ displayName }}</td>
          </tr>
          <tr>
            <td class="k">{{$t('Balance.Lastlogintime')}}</td>
            <td class="v">{{ lastLoginTime }}</td>
          </tr>
          <tr>
            <td class="k">{{$t('Balance.LastloginIP')}}</td>
            <td class="v">{{ lastLoginIp }}</td>
          </tr>
          </tbody>
        </table>

        <!-- 右：Credit Info -->
        <table class="tbl">
          <thead>
          <tr><th colspan="2">{{$t('Balance.CreditInfo')}}</th></tr>
          </thead>
          <tbody>
          <tr>
            <td class="k">{{$t('Balance.Currency')}}</td>
            <td class="v num">{{ currency }}</td>
          </tr>
          <tr>
            <td class="k">{{$t('Balance.CashBalance')}}</td>
            <td class="v num">{{ fmtMoney(cashBalance) }}</td>
          </tr>
          <tr>
            <td class="k">{{$t('Balance.Outstanding')}}</td>
            <td class="v num">{{ fmtNum(outstanding) }}</td>
          </tr>
          <tr>
            <td class="k">{{$t('Balance.GivenCredit')}}</td>
            <td class="v num">{{ fmtMoney(givenCredit) }}</td>
          </tr>
          <tr>
            <td class="k">{{$t('Balance.BetCredit')}}</td>
            <td class="v num b">{{ fmtMoney(betCredit) }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import TopNav from "@/components/TopNav.vue";
import { getMeApi } from "@/api/account";
import { getWalletBalanceApi } from "@/api/wallet";

export default {
  components: { TopNav },

  data() {
    return {
      // header
      username: this.$store.getters["auth/user"]?.username || "",
      currency: "KHR",
      topBalance: 0,

      // account info
      account: "",
      displayName: "",
      lastLoginTime: "",
      lastLoginIp: "",

      // credit info
      cashBalance: 0,
      outstanding: 0,
      givenCredit: 0,
      betCredit: 0
    };
  },

  mounted() {
    this.$updateViewport(1280);
    this.loadAll();
  },

  methods: {
    onNav(key) {
      if (key === "news" || key === "lotto") return this.$router.push("/lotto");
      if (key === "report") return this.$router.push("/report");
      if (key === "balance") return;
      if (key === "changePassword") return this.$router.push("/change-password");
      alert("Coming soon");
    },
    onSub() {},

    async loadAll() {
      await Promise.all([this.loadMe(), this.loadWallet()]);
    },

    async loadMe() {
      try {
        const res = await getMeApi();
        const d = res && res.data ? res.data : res;

        this.account = d.username || "";
        this.displayName = d.displayName || ""; // 老站空也OK
        this.lastLoginTime = this.fmtTime(d.lastLoginAt);
        this.lastLoginIp = d.lastLoginIp || "";
      } catch (e) {
        console.error(e);
      }
    },

    async loadWallet() {
      try {
        const res = await getWalletBalanceApi();
        const d = res && res.data ? res.data : res;

        this.currency = d.currency || "KHR";

        // ✅ 关键：用 displayBalance（不提前显示未发布结算）
        const display = Number(d.displayBalance ?? 0);

        this.topBalance = display;     // 顶部 Welcome 的余额
        this.cashBalance = display;    // Cash Balance 显示
        this.betCredit = display;      // Bet Credit 显示（跟截图一致）

        this.outstanding = Number(d.outstanding ?? 0);
        this.givenCredit = 0;
      } catch (e) {
        console.error(e);
      }
    },

    fmtMoney(v) {
      return Number(v || 0).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },

    fmtNum(v) {
      return Number(v || 0).toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
    },

    fmtTime(ts) {
      if (!ts) return "";
      const d = new Date(ts);
      if (isNaN(d.getTime())) return String(ts);
      const pad = (n) => String(n).padStart(2, "0");

      // 修改为截图格式：DD-MM-YYYY HH:mm:ss
      return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    }
  }
};
</script>

<style scoped>
.page { background:#fff; min-height:100vh; min-width: 1280px; }
.wrap { padding: 10px 0 0 0; }

.grid{
  display:flex;
  gap:10px;
  align-items:flex-start;
  justify-content: flex-start;
  margin: 0;
}

.tbl{
  width: 295px;
  border-collapse: collapse;
  font-size: 13px;
  border: 1px solid #3C5AA0;
  table-layout: fixed;
}

.tbl th{
  background:#3C5AA0;
  color:#FFFFFF;
  padding: 0;
  height: 25px;
  font-weight: 600;
  text-align:center;
  font-size: 14px;
}

.tbl td{
  border: 1px solid #3C5AA0;
  padding: 0 8px;
  background: #fff;
  height: 23px;
  color: #000000;
  font-weight: 600;
}

.k{ 
  width: 50%; 
  font-weight: 600; 
  color: #000000;
}
.v{ 
  width: 50%; 
  color: #000000;
  font-weight: 600;
}
.num{ text-align:right; }
.b{ font-weight: 600; color: #000000; }
</style>
